import React from 'react';
import Lottie from "lottie-react";
import {withTranslation} from "react-i18next";
import vrImg from "../../../../assets/course_img/vr_step_icon.svg";
import { Button, FormControl, FormGroup } from "react-bootstrap";


function VRTrainingStart(props) {    
    const handleStartTraining = () => {    
        props.handleInitVRTraining();        
    };
    return <div className='Screen container' style={{display:"flex", flexDirection:"column", alignContent:"space-between",justifyContent:"space-evenly"}}>          
                <div style={{justifyContent:"center",display: "flex", flexDirection:"column", alignContent:"center", alignItems:"center"}}>
                    <img src={vrImg} alt={props.t('Class logo')} className="w-50"/>
                    <h5 style={{marginTop:"20px", fontSize:"24pt"}} className="text-center preshift_text ">
                        {props.t("Practical assignment in virtual reality")}</h5>
                    <p style={{fontSize:"14pt"}}>{props.t("To start the passage, click on the button and follow the instructions.")}</p>
                </div>
                <div style={{justifyContent:"center","display": "flex"}}>
                    <Button style={{"padding":"35px",fontSize:"30px"}} className="MuiButton Btn Btn_success btn btn-primary text-center" onClick={handleStartTraining}   >
                        <span className="text-center">{props.t('Start a practical assignment')}</span>
                    </Button>
                </div>
            </div>
}
export default withTranslation()(VRTrainingStart);